import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";


export const valuationEventPropertiesGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: "valuationProjectProperty.valuationId",
    field: "Oid",
    width: 200,
  },
  {
    title: "valuationProjectProperty.propertyType",
    field: "PropertyTypeIDDescription",
    width: 200
  },
  {
    title: "valuationProjectProperty.propertyName",
    field: "buildingName",
    width: 200
  },
  {
    title: "valuationProjectProperty.street",
    field: "Street1",
    width: 200
  },
  {
    title: "valuationProjectProperty.postalCode",
    field: "PostalCodeManual",
    width: 200
  },
  {
    title: "valuationProjectProperty.community",
    field: "MunicipalManual",
    width: 200
  },
  {
    title: "valuationProjectProperty.federalState",
    field: "provinceDescription",
    width: 200
  },
  {
    title: "valuationProjectProperty.country",
    field: "CountryIDDescription",
    width: 280
  },
  {
    title: "valuationProjectProperty.portfolioName",
    field: "PortfolioName",
    width: 200
  },
  {
    title: "valuationProjectProperty.puidOnly",
    field: "ProjectStdID",
    width: 200
  },
  {
    title: "valuationProjectProperty.importName",
    field: "Import",
    width: 200
  }
];
